// extracted by mini-css-extract-plugin
export default {"bannerWrapper":"CookieConsentBanner_bannerWrapper__Pp7XX","bannerContainer":"CookieConsentBanner_bannerContainer__957Wm","bannerContent":"CookieConsentBanner_bannerContent__65oVC"};